/*
  "Request a quote" (Tally popup) — Premier Pool & Spa custom.
  Markup: snippets/quote-button.liquid  (<a data-quote-form="FORM_ID" data-product data-sku data-url>)
  - Loads https://tally.so/widgets/embed.js on demand (first click, or warmed up a few
    seconds after page load when a quote button is on the page) — never in <head>.
  - Opens the form as a centered modal with product / sku / url passed as hidden fields.
  - If the widget can't load, falls back to the link's own prefilled href in a new tab.
  - On product pages, shows/hides the button as the add-to-cart button is disabled/enabled
    (Impulse toggles that per variant), so it only appears for sold-out variants.
*/
(function (w, d) {
  'use strict';
  var SRC = 'https://tally.so/widgets/embed.js';
  var loading = null;

  function load() {
    if (w.Tally && w.Tally.openPopup) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var s = d.createElement('script');
      s.src = SRC;
      s.async = true;
      s.onload = function () { (w.Tally && w.Tally.openPopup) ? resolve() : reject(new Error('Tally missing')); };
      s.onerror = function () { loading = null; reject(new Error('Tally failed')); };
      d.head.appendChild(s);
    });
    return loading;
  }

  function openQuote(btn) {
    var id = btn.getAttribute('data-quote-form');
    var hidden = {
      product: btn.getAttribute('data-product') || '',
      sku: btn.getAttribute('data-sku') || '',
      url: btn.getAttribute('data-url') || location.href
    };
    load().then(function () {
      w.Tally.openPopup(id, {
        layout: 'modal',
        width: 560,
        overlay: true,
        hiddenFields: hidden,
        autoClose: 4000
      });
    }).catch(function () {
      w.open(btn.href, '_blank', 'noopener');
    });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quote-form]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openQuote(btn);
  });

  // Product forms (product page + quick view modals, which Impulse injects via ajax):
  // mirror the add-to-cart button's disabled state so the quote button shows only
  // for sold-out variants. Impulse toggles `disabled` on variant change.
  function bindForm(form) {
    if (form.__quoteBound) return;
    var atc = form.querySelector('[data-add-to-cart]');
    var quote = form.querySelector('.quote-btn');
    if (!atc || !quote) return;
    form.__quoteBound = true;
    var sync = function () { quote.hidden = !atc.disabled; };
    sync();
    new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
  }

  function bindAll() {
    var forms = d.querySelectorAll('form.product-single__form');
    for (var i = 0; i < forms.length; i++) bindForm(forms[i]);
  }

  var pending = null;
  function scheduleBind() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; bindAll(); }, 50);
  }

  function warmUp() {
    if (d.querySelector('[data-quote-form]:not([hidden])')) setTimeout(load, 3000);
  }

  function start() {
    bindAll();
    new MutationObserver(scheduleBind).observe(d.body, { childList: true, subtree: true });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  if (d.readyState === 'complete') { warmUp(); } else { w.addEventListener('load', warmUp); }
})(window, document);
